module.exports = __webpack_public_path__ + "img/envmb.235911fc.png";